import { v5 as uuidv5 } from 'uuid';

const identityChannelKey = uuidv5(
  'https://certi.programmers.co.kr/certi-itentity-channel',
  uuidv5.URL,
);

if (process.env.NODE_ENV === 'test') {
  globalThis.BroadcastChannel = require('node:worker_threads').BroadcastChannel;
}

export const createIdentityBroadcastChannel = (): BroadcastChannel => new BroadcastChannel(identityChannelKey);
